import { geminiService } from '../gemini';
import { isDev } from '../../env';
import { logger } from '../../logger';
import type { GeminiResponse } from '../gemini';

/**
 * Service Gemini spécialisé pour les FORMULAIRES uniquement
 * 
 * Ce service encapsule le geminiService principal mais force toutes les
 * générations à être des formulaires, jamais des sondages de dates.
 * 
 * Utilisé exclusivement par apps/form-polls
 */
export class FormGeminiService {
  private static instance: FormGeminiService;

  static getInstance(): FormGeminiService {
    if (!FormGeminiService.instance) {
      FormGeminiService.instance = new FormGeminiService();
    }
    return FormGeminiService.instance;
  }

  private constructor() {
    // Constructeur privé pour le pattern singleton
  }

  /**
   * Force toujours le type "form" pour les formulaires
   * 
   * Dans le contexte des formulaires, peu importe ce que dit l'utilisateur,
   * nous générons TOUJOURS un formulaire. C'est la garantie de ne jamais
   * créer un sondage de date par erreur.
   */
  async generatePollFromText(
    userInput: string,
    pollTypeOverride?: "date" | "form", // ignoré, toujours "form"
    attachedFile?: any,
  ): Promise<GeminiResponse> {
    if (isDev()) {
      logger.info(
        `FormGeminiService: Force "form" pour l'entrée: "${userInput.substring(0, 50)}..."`,
        "api",
      );
    }

    // Force le type "form" peu importe l'override
    return geminiService.generatePollFromText(userInput, "form", attachedFile);
  }

  /**
   * Délégation des autres méthodes au service principal
   */
  async testConnection(): Promise<boolean> {
    return geminiService.testConnection();
  }

  async chatAboutPoll(
    userInput: string,
    context?: string,
  ): Promise<string> {
    // Pour le chat, on peut déléguer directement car il n'y a pas de risque
    // de génération de poll dans le chat
    return geminiService.chatAboutPoll(userInput, context);
  }
}

// Export singleton pour les formulaires
export const formGeminiService = FormGeminiService.getInstance();
